import { createAction } from 'redux-actions'
import { REQUEST_COUPON_DATA, SET_COUPON_DATA, SET_COUPON_STATE } from '../constants/couponConstant'

export let requestCouponData = createAction(REQUEST_COUPON_DATA)
export let setCouponData = createAction(SET_COUPON_DATA)
export let setCouponState = createAction(SET_COUPON_STATE)
